require('./knockout-init');

module.exports = window.ko;
